import axios from 'axios';

// [DEV | STAGING | PRODUCTION] to define where requests are sent
let ENV = "PRODUCTION";

let api_url = 'https://api.qrqinect.com/';
let fb_redirect_url = 'https://qr.saymore.net/facebookAuth';
switch(ENV) {
    case "DEV":
        api_url = 'http://localhost:8080/';
        fb_redirect_url = 'http://localhost:8080/facebookAuth';
    break;
    case "STAGING":
        api_url = 'http://staging.api.qrqinect.com/';
        fb_redirect_url = 'http://staging.qr.saymore.net/facebookAuth';
    break;
    case "PRODUCTION":
        api_url = 'https://api.qrqinect.com/';
        fb_redirect_url = 'https://qr.saymore.net/facebookAuth';
    break;
    default:
        // already have default values set above, but linter complains about no default case
    break;
}

export const API_URL = api_url;
export const FB_REDIRECT_URL = fb_redirect_url;

export default class QRQinectAPI {
    static logScan = (qrCodeGUID) => {
        return axios.get(API_URL + 'api/v1/logScan', {
            params: {
                QRCode: qrCodeGUID
            }
        });
    }
    static getCampaignValues = (qrCodeGUID) => {
        return axios.get(API_URL + 'api/v1/getCampaignValues', {
            params: {
                QRCode: qrCodeGUID
            }
        });
    }
    static loginBuyer = (buyerToken, buyerEmail, buyerPassword, buyerType, buyerTypeID, receiveNewsLetter, redirectURL, qrCode) => {
        return axios.get(API_URL + 'api/v1/loginBuyer', {
            params: {
                token: buyerToken,
                type: buyerType,
                id: buyerTypeID,
                username: buyerEmail,
                password: buyerPassword,
                newsletter: receiveNewsLetter,
                redirect: redirectURL,
                qrCode: qrCode
            }
        });
    }
    // Register a buyer
    static registerBuyer = (buyerName, buyerEmail, buyerPassword, buyerImage,  registrationType, registrationTypeID, qrCodeGUID, receiveNewsLetter, redirectURL) => {
        return axios.get(API_URL + 'api/v1/registerBuyer', {
            params: {
                type: registrationType,
                id: registrationTypeID,
                img: buyerImage,
                QRCode: qrCodeGUID,
                name: buyerName,
                email: buyerEmail,
                password: buyerPassword,
                newsletter: receiveNewsLetter,
                redirect: redirectURL
            }
        });
    }
    // Register a buyer
    static registerNewBuyer = (buyerName, buyerEmail, buyerPassword, buyerImage,  registrationType, registrationTypeID, qrCodeGUID, receiveNewsLetter, redirectURL) => {
        return axios.get(API_URL + 'api/v1/registerNewBuyer', {
            params: {
                type: registrationType,
                id: registrationTypeID,
                img: buyerImage,
                QRCode: qrCodeGUID,
                name: buyerName,
                email: buyerEmail,
                password: buyerPassword,
                newsletter: receiveNewsLetter,
                redirect: redirectURL
            }
        });
    }

    static sendUpdateBuyerPasswordEmail = (email) => {
        return axios.get(API_URL + 'api/v1/sendUpdateBuyerPasswordEmail', {
            params: {
                Email: email
            }
        });
    }

    static updateBuyerPassword = (token, buyerID, password) => {
        return axios.get(API_URL + 'api/v1/updateBuyerPassword', {
            params: {
                Token: token,
                BuyerID: buyerID,
                Password: password
            }
        });
    }

    static sendCreateBuyerPasswordEmail = (email) => {
        return axios.get(API_URL + 'api/v1/sendCreateBuyerPasswordEmail', {
            params: {
                Email: email
            }
        });
    }

    static createBuyerPassword = (token, buyerID, password) => {
        return axios.get(API_URL + 'api/v1/createBuyerPassword', {
            params: {
                Token: token,
                BuyerID: buyerID,
                Password: password
            }
        });
    }

    static getBuyer = (token) => {
        return axios.get(API_URL + 'api/v1/getBuyer', {
            params: {
                Token: token
            }
        });
    }

    static getBuyerStats = (token) => {
        return axios.get(API_URL + 'api/v1/getBuyerStats', {
            params: {
                Token: token
            }
        });
    }

    static getBuyerStatsPrelim = (token) => {
        return axios.get(API_URL + 'api/v1/getBuyerStatsPrelim', {
            params: {
                Token: token
            }
        });
    }

    static getQRCodeStats = (token, qrCode) => {
        return axios.get(API_URL + 'api/v1/getQRCodeStats', {
            params: {
                Token: token,
                QRCode: qrCode
            }
        });
    }

    static getBuyerBusinessCodes = (token) => {
        return axios.get(API_URL + 'api/v1/getBuyerBusinessCodes', {
            params: {
                Token: token
            }
        });
    }

    static getQRCodeBackgroundShapes = () => {
        return axios.get(API_URL + 'api/v1/getQRCodeBackgroundShapes');
    }

    static getDownloadQRURL = (QRGUID) => {
        return API_URL + '/api/v1/downloadQR?QRCode=' + QRGUID;
    }

    // Register a receiver
    static registerReceiver = (receiverName, receiverEmail, receiverImage,  registrationType, registrationTypeID, qrCodeGUID, receiveNewsLetter, redirectURL) => {
        return axios.get(API_URL + 'api/v1/registerReceiver', {
            params: {
                type: registrationType,
                id: registrationTypeID,
                img: receiverImage,
                QRCode: qrCodeGUID,
                name: receiverName,
                email: receiverEmail,
                newsletter: receiveNewsLetter,
                redirect: redirectURL,
                sendDownloadVideoLink: true
            }
        });
    }

    // Create a Referral
    static createReferral = (qrCodeGUID, referredBy, name, email, phone, additionalInformation) => {
        return axios.get(API_URL + 'api/v1/createReferral', {
            params: {
                QRCodeGUID: qrCodeGUID,
                ReferredBy: referredBy,
                Name: name,
                Email: email,
                Phone: phone,
                AdditionalInformation: additionalInformation
            }
        });
    }

    // Create a Rating
    static createRating = (qrCodeGUID, rating, review) => {
        return axios.get(API_URL + 'api/v1/createQRCodeRating', {
            params: {
                QRCodeGUID: qrCodeGUID,
                Rating: rating,
                Review: review
            }
        });
    }

    static sendBuyerAccountEmail = (email) => {
        return axios.get(API_URL + 'api/v1/sendBuyerAccountEmail', {
            params: {
                email: email
            }
        });
    }

    // get QRCode
    static getQRCode = (qrCodeGUID) => {
        return axios.get(API_URL + 'api/v1/getQRCode', {
            params: {
                QRCode: qrCodeGUID
            }
        });
    }

    // Activate QRCode
    static activateQRCode = (qrCodeGUID, nickname) => {
        return axios.get(API_URL + 'api/v1/activateQRCode', {
            params: {
                QRCodeGUID: qrCodeGUID,
                Nickname: nickname
            }
        });
    }

    static allowAddVideoToQRCode = (buyerToken, qrGUID) => {
        return axios.get(API_URL + 'api/v1/allowAddVideoToQRCode', {
            params: {
                Token: buyerToken,
                qrGUID: qrGUID
            }
        })
    }

    static updateSendScanNotifications = (token, qrCodeGUID, newValue) => {
        return axios.get(API_URL + 'api/v1/updateSendScanNotifications', {
            headers: { "Authorization": token, "Content-Type": "application/x-www-form-urlencoded" },
            params: {
                Token: token,
                Type: "QRCode",
                ID: qrCodeGUID,
                SendScanNotifications: newValue
            }
        });
    }

    static updateIncludeInStatistics = (token, qrCodeGUID, newValue) => {
        return axios.get(API_URL + 'api/v1/updateIncludeInStatistics', {
            headers: { "Authorization": token, "Content-Type": "application/x-www-form-urlencoded" },
            params: {
                Token: token,
                Type: "QRCode",
                ID: qrCodeGUID,
                IncludeInStatistics: newValue
            }
        });
    }

    static updateScanNotifications = (token, buyerID, newState) => {
        axios.get(API_URL + 'api/v1/updateSendScanNotifications', {
            headers: { "Authorization": token, "Content-Type": "application/x-www-form-urlencoded" },
            params: {
                Token: token,
                Type: "Buyer",
                ID: buyerID,
                SendScanNotifications: newState
            }
        });
    }

    static resetQRCode = (token, qrCodeGUID) => {
        return axios.get(API_URL + 'api/v1/resetQRCode', {
            params: {
                Token: token,
                QRCode: qrCodeGUID
            }
        });
    }

    // Update a QRCode Name
    static updateQRCodeName = (qrCodeGUID, nickname) => {
        return axios.get(API_URL + 'api/v1/updateQRCodeName', {
            params: {
                QRCodeGUID: qrCodeGUID,
                Nickname: nickname
            }
        });
    }

    // Update a QRCode Name
    static setQRCodeRedirect = (qrCodeGUID, buyerID, name, redirectURL) => {
        return axios.get(API_URL + 'api/v1/addRedirect', {
            params: {
                QRCode: qrCodeGUID,
                Buyer: buyerID,
                Name: name,
                RedirectURL: redirectURL
            }
        });
    }

    static sendSMSToContact = (token, qrCodeGUID, buyerID, contactID, smsTypeID, phone, message) => {
        return axios.get(API_URL + 'api/v1/sendSMS', {
            params: {
                Token: token,
                QRCodeGUID: qrCodeGUID,
                BuyerID: buyerID,
                ContactID: contactID,
                SMSTypeID: smsTypeID,
                Phone: phone,
                Message: message
            }
        });
    }

    static getReplacementText = (qrCodeGUID, text) => {
        return axios.get(API_URL + 'api/v1/getReplacementText', {
            params: {
                QRCodeGUID: qrCodeGUID,
                Text: text
            }
        });
    }

    static sendCassiesCookieEmail = (recipeintName, recipientEmail, uploadLink) => {
        return axios.get(API_URL + 'api/v1/sendCassieClientRegistrationEmail', {
            params: {
                RecipeintName: recipeintName,
                RecipientEmail: recipientEmail,
                UploadLink: uploadLink
            }
        });
    }

    static assignCustomHTMLToQRCode = (parameters) => {
        const form = new FormData()
        for ( const key in parameters ) {
            form.append(key, parameters[key]);
        }
        return axios.post(API_URL + 'api/v1/assignCustomHTMLToQRCode', form);
    }

    static sendBusinessQRCodeToClient = (parameters) => {
        // const form = new FormData()
        // for ( const key in parameters ) {
        //     form.append(key, parameters[key]);
        // }
        return axios.get(API_URL + 'api/v1/sendBusinessQRCodeToClient', {
            params: {
                BuyerID: parameters["BuyerID"],
                QRCode: parameters["QRCode"],
                ClientEmail: parameters["ClientEmail"],
                ClientMessage: parameters["ClientMessage"]
            }
        });
    }

    static createBusinessQRCode = (parameters) => {
        const form = new FormData()
        for ( const key in parameters ) {
            form.append(key, parameters[key]);
        }
        return axios.post(API_URL + 'api/v1/generateQRCode', form);
    }
}

// Preference related calls and constants
QRQinectAPI.Preference = class {
    static Constants = class {
        static SHOW_SEND_SMS_TO_CONTACT = 1;
        static SEND_SMS_TO_CONTACT_MESSAGE = 2;
        static SEND_SMS_AUTOMATED_REMINDER = 3;
        static AUTOMATED_REMINDER_SMS_DAYS = 4;
        static AUTOMATED_REMINDER_SMS_SEND_HOUR_UTC = 5;
        static QR_UPLOAD_VIDEO_WITHOUT_AUTH = 6;
    }

    static getPreference = (type, typeID, prefID) => {
        return axios.get(API_URL + 'api/v1/getObjectPreference', {
            params: {
                Type: type,
                TypeID: typeID,
                PreferenceID: prefID
            }
        });
    }

    static getPreferencesByGroup = (type, typeID, groupID) => {
        return axios.get(API_URL + 'api/v1/getObjectPreferencesByByGroup', {
            params: {
                Type: type,
                TypeID: typeID,
                PreferenceGroupID: groupID
            }
        });
    }
}
// PreferenceGroup related calls and constants
QRQinectAPI.PreferenceGroup = class {
    static Constants = class {
        static MY_ACCOUNT = 1;
    }
}
// PreferenceGroup related calls and constants
QRQinectAPI.SMSType = class {
    static Constants = class {
        static AUTOMATIC_SCAN_REMINDER = 1;
        static MANUAL_SCAN_REMINDER = 2;
    }
}
// Add the API object to the window so that customHTML has access.
if (!window.QRQinectAPI) {
    window.QRQinectAPI = QRQinectAPI;
}


// WEBPACK FOOTER //
// ./src/QRQinectAPI.js